import * as api from "../api/index";

import {
  START_LOADING,
  END_LOADING,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  FETCH_COMPANY,
  FETCH_COMPANY_PUBLIC_DETAILS,
  FETCH_COMPANIES,
  CHECK_DOMAIN,
} from "./constants";
import {
  readFromCache,
  writeToCache,
  readFullItemFromCache,
  deleteFullItemFromCache,
} from "../utils/cache";

export const getCompanyLastModified = (searchQuery) => async (dispatch) => {
  try {
    const { data } = await api.companyLastModified(searchQuery);
    const lastModified = new Date(
      (await readFromCache(`companyLastModified`))?.toString()
    ).getTime();
    const lastModifiedOnline = new Date(
      data?.data[0]?.lastModified ||
        new Date(
          new Date().getTime() - 365 * 24 * 60 * 60 * 1000
        ).toLocaleString()
    ).getTime();

    if (lastModifiedOnline > lastModified || isNaN(lastModified)) {
      await deleteFullItemFromCache("companies_");
      await writeToCache(
        `companyLastModified`,
        data?.data[0]?.lastModified || null
      );
    }
  } catch (error) {
    console.log(error);
    console.log(error.response);
  }
};

export const getCompanies =
  (searchQuery, page, pageSize = 15) =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const key = `${searchQuery.search}_${page}_${pageSize}`;
      const {
        data: { data, numberOfPages },
      } =
        (await readFromCache(`companies_${key}`)) ||
        (await api.fetchCompanies(searchQuery, page, pageSize));
      dispatch({
        type: FETCH_COMPANIES,
        payload: { companies: data, numberOfPages: numberOfPages },
      });
      await writeToCache(`companies_${key}`, {
        data: { data: data, numberOfPages: numberOfPages },
      });
    } catch (error) {
      console.log(error.response);
    }
    dispatch({ type: END_LOADING });
  };

export const getCompany = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchCompany(id);
    dispatch({ type: FETCH_COMPANY, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getCompanyPublicDetails = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchCompanyPublicDetails(id);
    dispatch({ type: FETCH_COMPANY_PUBLIC_DETAILS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const createCompany = (company) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.addCompany(company);
    dispatch({ type: CREATE_COMPANY, payload: data });
    //history.push(`/item/${data._id}`)
  } catch (error) {
    console.log(error);
  }
  dispatch({ type: END_LOADING });
};

export const checkDomain = (domain) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.checkDomain(domain);
    dispatch({ type: END_LOADING });
    return data;
  } catch (error) {
    dispatch({ type: END_LOADING });
    throw error;
  }
};

// Cache management for company data
const clearCompanyCache = async () => {
  await deleteFullItemFromCache("company_");
};

const options = {
  position: "bottom-right",
  style: {
    backgroundColor: "midnightblue",
    border: "2px solid lightgreen",
    color: "lightblue",
    fontFamily: "Menlo, monospace",
    fontSize: "20px",
    textAlign: "center",
  },
  closeStyle: {
    color: "lightcoral",
    fontSize: "16px",
  },
};

const updateCompanyCacheLastModified = async () => {
  const lastModified = new Date(
    new Date().getTime() - 365 * 24 * 60 * 60 * 1000
  ).toLocaleString();
  await writeToCache(`companyLastModified`, lastModified);
};

const showUpdateSuccessFeedback = (msg, openSnackbar) => {
  openSnackbar(msg, 6000);
};

const showErrorUpdateFeedback = (msg, openSnackbar) => {
  openSnackbar(msg, 9000);
};

export const updateCompany =
  (id, company, openSnackbar) => async (dispatch) => {
    try {
      await clearCompanyCache();
      const { data } = await api.updateCompany(id, company);
      dispatch({ type: UPDATE_COMPANY, payload: data });

      // Update cache with new last modified date
      await updateCompanyCacheLastModified();
      // Show success feedback to user
      showUpdateSuccessFeedback("Company Updated successfully", openSnackbar);
    } catch (error) {
      console.log(error);
      showErrorUpdateFeedback(error.message, openSnackbar);
    }
  };

export const deleteCompany = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteCompany(id);
    dispatch({ type: DELETE_COMPANY, payload: id });
    openSnackbar("Company deleted successfully");
    await writeToCache(
      `companyLastModified`,
      new Date(
        new Date().getTime() - 365 * 24 * 60 * 60 * 1000
      ).toLocaleString()
    );
  } catch (error) {
    console.log(error.response);
  }
};
